import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconController20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconController20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.25 4h-3.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5m-3.5-1.5a2.25 2.25 0 0 0 0 4.5h3.5a2.25 2.25 0 0 0 2.122-1.5h6.378a.75.75 0 0 0 0-1.5h-6.378A2.25 2.25 0 0 0 8.25 2.5zm12 8.5a.75.75 0 0 0 0-1.5h-2.878A2.25 2.25 0 0 0 11.75 8h-3.5a2.25 2.25 0 0 0-2.122 1.5H3.25a.75.75 0 0 0 0 1.5h2.878a2.25 2.25 0 0 0 2.122 1.5h3.5a2.25 2.25 0 0 0 2.122-1.5zm-8.5-1.5h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5m1.378 7A2.25 2.25 0 0 0 11.75 18h3.5a2.25 2.25 0 0 0 0-4.5h-3.5A2.25 2.25 0 0 0 9.628 15H3.25a.75.75 0 0 0 0 1.5zM11.75 15h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconController20);
